import { type FieldErrors, type UseFormRegister } from 'react-hook-form';
import { Grid, TextField, Alert } from '@mui/material';
import type { AfiliadoFormValues } from '../afiliadoSchema';

interface Props {
  register: UseFormRegister<AfiliadoFormValues>;
  errors: FieldErrors<AfiliadoFormValues>;
}

export default function TabAfiliacion({ register, errors }: Props) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Alert severity="info">
          La condicion de afiliado al sindicato determina los aportes automaticos
          (Sindical 2% para afiliados, Solidario 1% para no afiliados). Los aportes
          adicionales por afiliado se configuran en el tab <strong>Aportes Extra</strong>.
        </Alert>
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          {...register('fecha_alta_sistema')}
          type="date"
          fullWidth
          label="Fecha de afiliacion"
          InputLabelProps={{ shrink: true }}
          error={!!errors.fecha_alta_sistema}
          helperText={errors.fecha_alta_sistema?.message ?? 'Fecha en que se afilio al sindicato'}
        />
      </Grid>

      {/*
        NOTA:
        - El campo "es_afiliado" (boolean) podria agregarse aca a futuro como
          flag explicito. Por ahora se infiere del campo `estado`:
            - estado=activo -> es afiliado activo -> aplica Sindical 2%
            - estado=baja -> ya no es afiliado -> aplica Solidario 1% si tiene RL
        - Esto se afinara cuando implementemos la DDJJ (Fase 4) y se cierre la
          definicion con ATSA.
      */}
    </Grid>
  );
}
